export function initSectionProjects() {
  const sections = document.querySelectorAll('.section_projects');
  if (!sections.length) return;

  sections.forEach((section) => {
    const projectItems = Array.from(section.querySelectorAll('.project_list-item'));
    const stepper = section.querySelector('.projects_stepper');
    const dotTemplate = stepper?.querySelector('.projects_dot-wrapper');

    if (!stepper || !dotTemplate || !projectItems.length) return;

    const dots = buildStepper(stepper, dotTemplate, projectItems.length);
    let rafId = null;

    const setActiveIndex = (index) => {
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    };

    const updateActiveIndex = () => {
      rafId = null;

      const viewportCenter = window.innerHeight / 2;
      let activeIndex = 0;
      let smallestDistance = Number.POSITIVE_INFINITY;

      projectItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.top + rect.height / 2;
        const distance = Math.abs(itemCenter - viewportCenter);

        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      setActiveIndex(activeIndex);
    };

    const requestUpdate = () => {
      if (rafId !== null) return;
      rafId = window.requestAnimationFrame(updateActiveIndex);
    };

    requestUpdate();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  });
}

function buildStepper(stepper, dotTemplate, itemCount) {
  const template = dotTemplate.cloneNode(true);
  stepper.innerHTML = '';

  const dots = [];

  for (let index = 0; index < itemCount; index += 1) {
    const dot = template.cloneNode(true);
    stepper.appendChild(dot);
    dots.push(dot);
  }

  return dots;
}
